<template>
  <v-container id="logs-web-dialog">
    <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
    //-->

    <v-dialog
      v-model="dialog"
      scrollable
      max-width="1200px"
      fullscreen
      persistent
      no-click-animation
    >
      <v-card
        max-height="900px"
        class="backdrop dialog-card"
        id="swal_log_dialog"
      >
        <v-overlay absolute :value="overlay_loading">
          <v-progress-circular
            indeterminate
            :size="80"
            :width="7"
            color="secondary"
          ></v-progress-circular>
        </v-overlay>

        <v-card-text
          class="backdrop pa-0 white--text"
          style="overflow-y: scroll"
        >
          <v-container class>
            <v-stepper
              v-model="currentStep"
              dark
              vertical
              color="secondary"
              non-linear
              elevation="2"
            >
              <v-stepper-header>
                <div class="stepper_header_container">
                  <h2 class="stepper_header_text text-uppercase">Web Editor</h2>
                </div>
              </v-stepper-header>
              <v-stepper-items dark>
                <div v-for="(log, index) in logs_data" :key="`Log : ${index}`">
                  <v-stepper-step
                    color="secondary"
                    editable
                    :step="index + 1"
                    class="stepper_step_header"
                  >
                    <h2
                      v-if="
                        LookupDivisionName(log.logEntryID_LogDivisionID)
                          .length == 0 || log.districts.length == 0
                      "
                    >
                      New Log
                    </h2>
                    <h2 v-else>
                      {{ LookupDivisionName(log.logEntryID_LogDivisionID) }} -
                      {{ log.time }} {{ log.districts }}:
                      {{ log.title }}
                    </h2>
                    <small class="pt-1"
                      >Log {{ index + 1 }} of {{ logs_data.length }}</small
                    >
                  </v-stepper-step>

                  <v-stepper-content
                    dark
                    :step="index + 1"
                    color="secondary"
                    class="stepper_content"
                  >
                    <v-form
                      v-model="log.valid"
                      ref="logForm"
                      v-if="currentStep == index + 1"
                    >
                      <h3 class="mt-2">Web Info</h3>
                      <v-card
                        color="backdrop lighten-2"
                        elevation="2"
                        class="mt-1 mb-3 pa-3"
                      >
                        <v-row dense>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="log.web_title"
                              label="Web Incident Title"
                              maxlength="85"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="log.web_location"
                              label="Web Incident Location"
                              maxlength="60"
                            ></v-text-field>
                          </v-col> </v-row
                      ></v-card>

                      <h3
                        :class="{
                          'mt-1': true,
                          detail_error: log.webDescription.length > editorLimit,
                        }"
                      >
                        Web Details
                      </h3>
                      <tiptap
                        v-model="log.webDescription"
                        :characterLimit="editorLimit"
                        :htmlLimit="editorLimit"
                        uniqueID="tiptap3"
                        ref="webDescription_editor"
                      ></tiptap>
                    </v-form>

                    <!--Stepper buttons-->
                    <v-card
                      class="backdrop lighten-2 pa-1 mt-4"
                      elevation="4"
                      v-if="currentStep == index + 1"
                    >
                      <v-tooltip bottom :disabled="$vuetify.breakpoint.xs">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="secondary"
                            class="black--text mx-2"
                            icon
                            @click="viewLog(index)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="31">$vuetify.icons.info</v-icon>
                          </v-btn>
                        </template>
                        <span>View log</span>
                      </v-tooltip>

                      <v-tooltip bottom :disabled="$vuetify.breakpoint.xs">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="secondary"
                            class="black--text mx-2"
                            icon
                            @click="downloadLogDetails(index)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="31">$vuetify.icons.download</v-icon>
                          </v-btn>
                        </template>
                        <span>Copy log details</span>
                      </v-tooltip>

                      <!-- <v-tooltip bottom :disabled="$vuetify.breakpoint.xs">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="secondary"
                            class="black--text mx-2"
                            icon
                            :disabled="!log.valid"
                            @click="priorToSaveLog(index)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="30">$vuetify.icons.save</v-icon>
                          </v-btn>
                        </template>
                        <span>Save this log</span>
                      </v-tooltip>

                      <v-tooltip bottom :disabled="$vuetify.breakpoint.xs">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="secondary"
                            class="black--text mx-2"
                            icon
                            :disabled="!log.valid || !canSyncCurrentLog(index)"
                            @click="priorToSyncLog(index)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="30">$vuetify.icons.news</v-icon>
                          </v-btn>
                        </template>
                        <span>Sync this log to News</span>
                      </v-tooltip> -->

                      <v-tooltip bottom :disabled="$vuetify.breakpoint.xs">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            color="red"
                            icon
                            class="black--text mx-2"
                            @click="priorToRemoveLog(index)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon size="31">$vuetify.icons.remove</v-icon>
                          </v-btn>
                        </template>
                        <span>Remove this log</span>
                      </v-tooltip>
                    </v-card>
                    <div class="my-2"></div>
                  </v-stepper-content>
                </div>

                <div v-if="logs_data.length == 0" class="pa-3">
                  <h3>No Logs Found</h3>
                </div>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-card-text>

        <v-card-actions class="backdrop lighten-1 border-card dialog-actions">
          <!-- ARROWS -->
          <v-tooltip top :disabled="$vuetify.breakpoint.xs">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                class="black--text mr-1"
                @click="stepLeft"
                icon
                :disabled="isFirstStep()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="32">$vuetify.icons.arrowLeft</v-icon>
              </v-btn>
            </template>
            <span>Go to the previous log</span>
          </v-tooltip>

          <small v-if="currentStep != -1"
            >{{ currentStep }}/{{ logs_data.length }}</small
          >

          <v-tooltip top :disabled="$vuetify.breakpoint.xs">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                class="black--text ml-1"
                @click="stepRight"
                icon
                :disabled="isLastStep()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="32">$vuetify.icons.arrowRight</v-icon>
              </v-btn>
            </template>
            <span>Go to the next log</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <div>
            <v-tooltip top :disabled="$vuetify.breakpoint.xs">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  class="black--text mx-1"
                  icon
                  large
                  @click="priorToSaveAll"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="28">$vuetify.icons.saveall</v-icon>
                </v-btn>
              </template>
              <span>Save all logs</span>
            </v-tooltip>

            <v-tooltip top :disabled="$vuetify.breakpoint.xs">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  class="black--text mx-1"
                  icon
                  large
                  :disabled="!canSyncAllLogs()"
                  @click="priorToSyncAllLogs"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="30">$vuetify.icons.newsall</v-icon>
                </v-btn>
              </template>
              <span>Sync all logs to News</span>
            </v-tooltip>
          </div>

          <v-tooltip top :disabled="$vuetify.breakpoint.xs">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                class="black--text"
                icon
                large
                @click="priorToClose"
                v-bind="attrs"
                v-on="on"
                ><v-icon size="32">$vuetify.icons.windowClose</v-icon></v-btn
              >
            </template>
            <span>Close this dialog</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>

      <v-dialog
        v-model="view_log_dialog"
        v-if="view_log_entry"
        scrollable
        max-width="1200px"
        :overlay-opacity="0.7"
        transition="dialog-bottom-transition"
      >
        <v-card max-height="900px" class="backdrop dialog-card">
          <v-card-title class="backdrop lighten-1 dialog-title">
            <span class="text-h5"
              >{{
                LookupDivisionName(view_log_entry.logEntryID_LogDivisionID)
              }}
              - {{ view_log_entry.time }} {{ view_log_entry.districts }}:
              {{ view_log_entry.title }}</span
            >
          </v-card-title>
          <v-card-text class="backdrop pa-0 white--text">
            <v-container>
              <v-row dense no-gutters>
                <v-col cols="12" md="12">
                  <div v-if="partieDOBValid(view_log_entry.date)">
                    <span
                      ><strong>Date:</strong>
                      {{ formatPartieDOB(view_log_entry.date) }}
                    </span>
                  </div>

                  <div>
                    <span
                      ><strong>Location:</strong>
                      {{ view_log_entry.location }}
                    </span>
                  </div>
                  <div>
                    <span
                      ><strong>Case:</strong>
                      {{ view_log_entry.casenum }}
                    </span>
                  </div>

                  <div>
                    <span
                      ><strong>Addt'l Case:</strong>
                      {{ view_log_entry.additionalCaseNumbers }}
                    </span>
                  </div>
                  <div>
                    <span
                      ><strong>Sgt:</strong>
                      {{ view_log_entry.sergeant }}
                    </span>
                    <span
                      ><strong>Lt:</strong>
                      {{ view_log_entry.lieutenant }}
                    </span>
                  </div>

                  <div style="height: 8px" />
                </v-col>
              </v-row>

              <strong>Incident Details:</strong>
              <div v-html="view_log_entry.description"></div>

              <strong>Involved Party(s):</strong>
              <div
                v-for="(p, pindex) in view_log_entry.partiesInvolved"
                :key="pindex"
              >
                <div style="display: inline">
                  <strong style="display: inline">{{ p.involvement }}</strong
                  >:
                  {{ p.firstname }}
                  {{ p.lastname }}
                  <div style="display: inline" v-if="partieDOBValid(p.dob)">
                    ({{ formatPartieDOB(p.dob) }})
                  </div>
                </div>
                <div style="display: inline" v-if="p.description.length > 0">
                  {{ p.description }}
                </div>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions class="backdrop lighten-1 border-card">
            <v-spacer></v-spacer>

            <v-btn color="secondary" class="black--text" @click="closeViewLog">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../../scss/site.scss";

.dialog-card {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.dialog-title {
  margin-bottom: 2px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;
}
// .add-button {
//   left: 47.2%;
// }
.dialog-actions {
  align-self: center;
  width: 100%;
}

.custom-divider {
  height: 2px;
  background-color: black;
}

.border-card {
  margin: 2px;
}

.stepper_content {
  border-left: grey solid 1px;
}

.stepper_step_header {
  color: black !important;
}

.stepper_header_container {
  width: 80%;
}

.stepper_header_text {
  width: 100%;
}

.v-stepper__header {
  height: 52px;
}

.detail_error {
  color: var(--v-error-base);
}

.stepper-toolbar {
  border-radius: 4px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px;
}

@media only screen and (min-width: 1904px) {
  .dialog-actions {
    max-width: 1885px;
  }
}

@media only screen and (min-width: 1264px) and (max-width: 1904px) {
  .dialog-actions {
    max-width: 1285px;
  }
}

@media only screen and (max-width: 600px) {
  .dialog-actions {
    max-width: 100vw;
  }

  // .add-button {
  //   left: 44.5%;
  // }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../../mixins/bus_common";
import tiptap from ".././tiptap.vue";
export default {
  name: "logs-web-dialog",
  mixins: [bus_common],
  props: {
    logEntryIDs: Array,
  },
  components: { tiptap },
  data() {
    return {
      dialog: true,
      overlay_loading: false,
      valid: false,
      field_rules: {
        required: (value) => !!value || "This field is required",
        min: (v) => v.length >= 8 || "Min 8 characters",
        max25: (v) => v.length <= 60 || "Max 60 characters",
        email: (value) => {
          const pattern =
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Please provide a valid email address";
        },
        min_phone: (v) =>
          v.length >= 14 || "Please enter a complete phone number",
        phone: (value) => {
          const pattern =
            /^\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^\d{10}$|^1\s\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^(1\s?)?\(\d{3}\)(\s|\-)?\d{3}\-\d{4}$/;
          return pattern.test(value) || "Please provide a valid phone number";
        },
        filerequired: (value) => !!value || "A signature image is required",
        incident_date_rules: (value) => {
          var bool = false;
          if (
            this.field_filters.incident_date_start == "" &&
            this.field_filters.incident_date_end == ""
          ) {
            bool = true;
          } else if (
            this.field_filters.incident_date_start != "" &&
            this.field_filters.incident_date_end != ""
          ) {
            bool = true;
          } else {
            bool = false;
          }
          return bool || "A valid date range must be entered using both fields";
        },
        modified_date_rules: (value) => {
          var bool = false;
          if (
            this.field_filters.modified_date_start == "" &&
            this.field_filters.modified_date_end == ""
          ) {
            bool = true;
          } else if (
            this.field_filters.modified_date_start != "" &&
            this.field_filters.modified_date_end != ""
          ) {
            bool = true;
          } else {
            bool = false;
          }
          return bool || "A valid date range must be entered using both fields";
        },
        assigned_date_rules: (value) => {
          var bool = false;
          if (
            this.field_filters.assigned_date_start == "" &&
            this.field_filters.assigned_date_end == ""
          ) {
            bool = true;
          } else if (
            this.field_filters.assigned_date_start != "" &&
            this.field_filters.assigned_date_end != ""
          ) {
            bool = true;
          } else {
            bool = false;
          }
          return bool || "A valid date range must be entered using both fields";
        },
        closed_date_rules: (value) => {
          var bool = false;
          if (
            this.field_filters.closed_date_start == "" &&
            this.field_filters.closed_date_end == ""
          ) {
            bool = true;
          } else if (
            this.field_filters.closed_date_start != "" &&
            this.field_filters.closed_date_end != ""
          ) {
            bool = true;
          } else {
            bool = false;
          }
          return bool || "A valid date range must be entered using both fields";
        },
      },
      logs_data: [],
      currentStep: -1,
      editorLimit: 3999,
      swal_target: "swal_log_dialog",
      view_log_entry: null,
      view_log_dialog: false,
      hasSavedLogs: false,
    };
  },
  methods: {
    priorToClose() {
      if (this.logs_data.length == 0) {
        this.closeDialog();
      } else {
        let callback = () => {
          this.closeDialog();
        };
        this.swall_diag(
          "Close?",
          "Are you sure you would like to close this dialog? Any unsaved changes or new logs will be lost.",
          "question",
          callback,
          "Yes",
          "No",
          null,
          this.swal_target
        );
      }
    },

    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$emit("closeDialog");
      }, 300);
    },

    viewLog(index) {
      let log = JSON.parse(JSON.stringify(this.logs_data[index]));
      this.view_log_entry = log;
      this.view_log_dialog = true;
    },

    closeViewLog() {
      this.view_log_dialog = false;
    },

    validateAllLogs() {
      for (let i = 0; i < this.logs_data.length; i++) {
        if (this.validateLog(i) == false) {
          return false;
        }
      }
      return true;
    },

    validateLog(index) {
      let sizeLimit = this.editorLimit;
      let log = JSON.parse(JSON.stringify(this.logs_data[index]));
      if (log.webDescription.length > sizeLimit) {
        let msg =
          "One or more of your log editor sections exceed the maximum text length allowed. <br/> <br/> Please reduce the content by either removing HTML formatting or shortening the text to meet the length requirements.";
        this.swall_it("Error!", msg, "error", null, null, this.swal_target);
        return false;
      }
      return true;
    },

    cleanUpAllLogsBeforeSaving() {
      let AllLogs = [];
      for (let i = 0; i < this.logs_data.length; i++) {
        let log = this.cleanUpLogBeforeSaving(i);
        AllLogs.push(log);
      }
      return AllLogs;
    },

    // Returns a copy of the log
    cleanUpLogBeforeSaving(index) {
      let log = JSON.parse(JSON.stringify(this.logs_data[index]));
      for (let i = 0; i < log.partiesInvolved.length; i++) {
        if (this.date_is_valid(log.partiesInvolved[i].dob) == false) {
          log.partiesInvolved[i].dob = "1900-01-01";
        }
      }
      return log;
    },

    priorToSaveAll() {
      if (this.validateAllLogs()) {
        let callback = () => {
          let LogEntries = this.cleanUpAllLogsBeforeSaving();
          this.saveAll(LogEntries);
        };
        this.swall_diag(
          "Save All?",
          `Are you sure you would like to save the web details for these ${this.logs_data.length} log(s) ?`,
          "question",
          callback,
          "Yes",
          "No",
          null,
          this.swal_target
        );
      }
    },

    async saveAll(logEntries) {
      var form = {
        token: this.$store.state.user.token,
        logEntries: logEntries,
      };

      let saveStatusMessage =
        "All the web details were successfully saved. You may now sync these logs to News.";
      this.overlay_loading = true;
      await this.$axios
        .post("/api/nw/UpdateLogsWebDetails", form)
        .then((response) => {
          this.swall_it(
            "Saved!",
            saveStatusMessage,
            "success",
            null,
            null,
            this.swal_target
          );
          this.hasSavedLogs = true;
          this.overlay_loading = false;
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
          this.overlay_loading = false;
        });
    },

    downloadLogDetails(index) {
      let log = JSON.parse(JSON.stringify(this.logs_data[index]));
      this.logs_data[index].web_title = log.title;
      this.logs_data[index].web_location = log.location;
      this.$refs.webDescription_editor[0].setContent(log.description);

      // Now that we replaced the content with the description we can
      // append the case number data
      let caseNumberHTML = this.generateCaseNumbersHTML(log);
      this.$refs.webDescription_editor[0].appendContent(caseNumberHTML);
    },

    generateCaseNumbersHTML(log) {
      // this is how tip tap does line breaks
      let html = "<p></p>";
      let contentAdded = false;

      if (log.casenum.length > 0) {
        html += `<p><strong>Case: ${log.casenum}</strong></p>`;
        contentAdded = true;
      }

      if (log.additionalCaseNumbers.length > 0) {
        html += `<p><strong>Addt'l Case: ${log.additionalCaseNumbers}</strong></p>`;
        contentAdded = true;
      }

      if (contentAdded) {
        return html;
      } else {
        return "";
      }
    },

    // May need this version later on
    // generateCaseNumbersHTML(log) {
    //   let html = "<ul>";

    //   if (log.casenum.length > 0) {
    //     html += `<li>Case#: ${log.casenum}</li>`;
    //   }

    //   if (log.additionalCaseNumbers.length > 0) {
    //     html += `<li>Addt'l Case#: ${log.additionalCaseNumbers}</li>`;
    //   }

    //   html += "</ul>";
    //   return html;
    // },

    canSyncAllLogs() {
      return this.hasSavedLogs;
    },

    priorToSyncAllLogs() {
      if (this.validateAllLogs()) {
        let callback = () => {
          const logEntryIDs = this.logs_data.map((log) => log.logEntryID);
          this.syncLogs(logEntryIDs);
        };
        this.swall_diag(
          "Sync All?",
          `Are you sure you would like to sync these ${this.logs_data.length} log(s) to News?`,
          "question",
          callback,
          "Yes",
          "No",
          null,
          this.swal_target
        );
      }
    },

    async syncLogs(logEntryIDs) {
      this.overlay_loading = true;
      var form = {
        token: this.$store.state.user.token,
        logEntryIDs: logEntryIDs,
      };
      await this.$axios
        .post("/api/nw/SyncToNews", form)
        .then((response) => {
          let callback = () => {
            this.closeDialog();
          };

          this.overlay_loading = false;
          this.swall_it(
            "Log(s) Synced!",
            "Please use the RPD News Admin App to continue. ",
            "success",
            callback,
            null,
            this.swal_target
          );
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
          this.overlay_loading = false;
        });
    },

    priorToRemoveLog(index) {
      let callback = () => {
        this.removeLog(index);
        if (this.logs_data.length == 0) {
          this.closeDialog();
        }
      };
      this.swall_diag(
        "Remove Log?",
        `Are you sure you would like to remove this log? Any unsaved changes will be lost.`,
        "question",
        callback,
        "Yes",
        "No",
        null,
        this.swal_target
      );
    },

    removeLog(index) {
      this.logs_data.splice(index, 1);
      this.currentStep =
        Math.min(this.currentStep, this.logs_data.length - 1) + 1;
      this.$nextTick(() => {
        this.$refs?.webDescription_editor[0]?.refreshEditor();
      });
    },

    fixLogDataDates() {
      // Any date fields from the server must be conveted to appear ioi nfield
      for (let i = 0; i < this.logs_data.length; i++) {
        this.logs_data[i].date = this.$moment(this.logs_data[i].date).format(
          "YYYY-MM-DD"
        );
        for (let j = 0; j < this.logs_data[i].partiesInvolved.length; j++) {
          this.logs_data[i].partiesInvolved[j].dob = this.$moment(
            this.logs_data[i].partiesInvolved[j].dob
          ).format("YYYY-MM-DD");

          // Any dates with '1900-01-01' should be set to empty
          if (this.logs_data[i].partiesInvolved[j].dob == "1900-01-01") {
            this.logs_data[i].partiesInvolved[j].dob = "";
          }
        }
      }
    },

    formatPartieDOB(date) {
      let format = this.$moment(new Date(date)).format("MM/DD/YYYY");
      if (format == "01/01/1900") {
        return "";
      } else {
        return format;
      }
    },

    partieDOBValid(date) {
      if (date == "1900-01-01T00:00:00") {
        return false;
      } else {
        return true;
      }
    },

    LookupDivisionName(divisionID) {
      if (this.divisions_list) {
        for (let index = 0; index < this.divisions_list.length; index++) {
          const element = this.divisions_list[index];
          if (element.logDivisionID == divisionID) {
            return element.displayName;
          }
        }
      }
      return "Division Not Found";
    },

    stepLeft() {
      this.currentStep = this.currentStep - 1;
    },

    stepRight() {
      this.currentStep = this.currentStep + 1;
    },

    isLastStep() {
      if (
        this.logs_data.length == this.currentStep ||
        this.logs_data.length == 0
      )
        return true;

      return false;
    },

    isFirstStep() {
      if (1 == this.currentStep || this.logs_data.length == 0) return true;

      return false;
    },

    async init() {
      var form = {
        token: this.$store.state.user.token,
        logEntryIDs: this.logEntryIDs,
        s_del: "f",
        dateGrouping: false,
      };
      this.overlay_loading = true;
      await this.$axios
        .post("/api/logs/GetByList", form)
        .then((response) => {
          this.logs_data = response.data;
          this.fixLogDataDates();
          this.overlay_loading = false;
        })
        .catch((error) => {
          this.hande_swal_error(error, this.swal_target);
          this.overlay_loading = false;
        });

      if (this.logs_data.length > 0) {
        setTimeout(() => {
          this.currentStep = 1;
        });
      }
    },
  },
  watch: {},

  computed: {
    divisions_list() {
      return this.$store.state.logDivisions;
    },
  },

  mounted() {
    this.init();
  },
};
</script>
